import { EventEmitter, Injectable, signal, WritableSignal } from "@angular/core";
import { InitialStateDto } from "../../../commondata/messages/initial-state-dto";
import { CustomSelectElement } from "./shared/custom-select-element-dto";
import { UiConstants } from "./shared/ui-constants";
import { MathContentMessage } from "../../../commondata/messages/messages-dto";
import { TranslateService } from "@ngx-translate/core";
import { SelectionDataDto } from "../../../commondata/messages/selection-data-dto";
import { ImageDataDto } from "../../../commondata/messages/image-data-dto";
import { TLInteractionDto } from "../../../commondata/messages/tl-interaction-dto";

const routes = {
  resourcePath: () => `docs`,
  resourceDoc: (docId: string) =>
    `${routes.resourcePath()}/${docId}/document.pdf`,
  resourcePreview: (docId: string) =>
    `${routes.resourcePath()}/${docId}/preview.jpg`,
};

@Injectable({
  providedIn: "root",
})
export class ModuleStateService {

  public guid: string = "";
  public docId: string = "";
  public sideDocInfo: any = { sideDocId: "", sideDocType: "", sideDocName: "" };
  public name: string = "";
  public isMine: boolean = false;
  public readOnly: boolean = false;
  public googleId: string = "";

  public onSetInitialState = new EventEmitter<InitialStateDto>();
  public isModuleInitialized = new EventEmitter<boolean>();
  public onAutoSavingChange = new EventEmitter<any>();
  public onBusyStateChange = new EventEmitter<boolean>();
  public onDirtyStateChange = new EventEmitter<boolean>();
  public onSaveStatusChange = new EventEmitter<number>();
  public onPrint = new EventEmitter<boolean>();
  public onOptimizeView = new EventEmitter<any>();
  public onZoomChange = new EventEmitter<number>();
  public onToggleFindText = new EventEmitter<boolean>();
  public onDownload = new EventEmitter<boolean>();
  public onStartPlay = new EventEmitter<any>();
  public onTalkingStart = new EventEmitter();
  public onTalkingEnd = new EventEmitter();
  public onMathContent = new EventEmitter<MathContentMessage>();
  public onMathOpen = new EventEmitter<boolean>();
  public onDocLanguageChanged = new EventEmitter<string>();
  public onLanguageChangedFromShell = new EventEmitter<string>();
  public onSearchSelection = new EventEmitter<string>();
  public onPasteSideSelection = new EventEmitter<SelectionDataDto>();
  public onCopySideSelection = new EventEmitter();
  public onSpeechRecognitionText = new EventEmitter<string>();
  public onImageInsert = new EventEmitter<ImageDataDto>();
  public onRequestCrop = new EventEmitter<void>();
  public onImageMapInsert = new EventEmitter<string>();
  public onTLInteraction = new EventEmitter<TLInteractionDto>();

  public index = 0;

  private _isDirty: boolean = false;
  private _saveStatus: number = 0;
  autoSaving: boolean = false;
  ttsEnabled: boolean = false;

  public voices: any[] = [];
  private _languages: CustomSelectElement[] = [];
  public get languages(): CustomSelectElement[] {
    return this._languages;
  }
  public set languages(value: CustomSelectElement[]) {
    this._languages = value;
    this.sortLanguages();
  }

  private _isLockedbyUser: boolean = false;
  get isLockedbyUser() {
    return this._isLockedbyUser;
  }
  set isLockedbyUser(value: boolean) {
    this._isLockedbyUser = value;
  }
  public languagesWithFlag: CustomSelectElement[] = [];
  public languagesNoFlag: CustomSelectElement[] = [];

  forceExit: boolean = false;
  private _isBusy: boolean = false;

  public docLanguage: string;
  public isLoaded: boolean = false;

  public isClaireEnabledInConfig: WritableSignal<boolean> = signal(false) ;


  constructor(
    private translateService: TranslateService
  ) {
    this.docLanguage = this.translateService.currentLang;
  }

  private sortLanguages() {
    if (!this.languages || this.languages.length == 0) return;
    this.languagesNoFlag = this.languages.filter(x => !x.icon || x.icon == UiConstants.FLAGS[0].icon);
    this.languagesWithFlag = this.languages.filter(x => x.icon && x.icon != UiConstants.FLAGS[0].icon);
  }

  get isDirty(): boolean {
    return this._isDirty;
  }
  set isDirty(value: boolean) {
    this._isDirty = value;
    this.onDirtyStateChange.next(value);
  }

  get saveStatus(): number {
    return this._saveStatus;
  }
  set saveStatus(value: number) {
    this._saveStatus = value;
    this.onSaveStatusChange.next(value);
  }

  getFilePath(docId: string) {
    return routes.resourceDoc(docId);
  }

  getCurrentFilePath() {
    return routes.resourceDoc(this.docId);
  }

  getCurrentPreviewImage() {
    return routes.resourcePreview(this.docId);
  }

  public setAutosaving(value?: boolean) {
    this.autoSaving = (value ? value : false);
    this.onAutoSavingChange.next(value);
    this.saveStatus = 1;
  }

  public getAutosaving(): boolean {
    return this.autoSaving;
  }


  public set isBusy(value: boolean) {
    this._isBusy = value;
    this.onBusyStateChange.next(value);
  }

  public get getBusy(): boolean {
    return this._isBusy;
  }

  public canDrop(type: string, ext?: string): boolean {
    if (ext && ext === 'doc') return false;
    let res = false;
    switch (type) {
      case 'application/pdf':
        res = true;
        break;

      case 'application/vnd.oasis.opendocument.text':
        res = true;
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        res = true;
        break;
      case 'application/msword':
        res = true;
        break;
      case 'application/text/plain':
        res = true;
        break;


      case 'application/supermappex':
        res = true;
        break;
      case 'application/supermappe':
        res = true;
        break;
    }
    if (!res) {
      switch (ext) {
        case 'sme':
          res = true;
          break;
        case 'doc':
          res = true;
          break;
        case 'docx':
          res = true;
          break;
        case 'pdf':
          res = true;
          break;
      }
    }
    return res;
  }

}

